import { FunctionComponent } from "react";

interface SignatureCounterProps {
  count: number;
  isDisabled: boolean;
}

const SignatureCounter: FunctionComponent<SignatureCounterProps> = ({
  count,
  isDisabled,
}) => {
  if (count) {
    return (
      <div className={`signature-counter ${isDisabled ? "disabled" : ""}`}>
        {count}
      </div>
    );
  } else {
    return <></>;
  }
};

export default SignatureCounter;
